import axios from "config/axios";
import { GenericListResponse, GenericResponse, Vehicle } from "shared/types";

export type VehicleTourInfo = {
  id: number | null;
  vehicle: Partial<Vehicle>;
  deliveryDate: string; //1970-01-01
  tourLength: number;
  link: string;
  createdBy: number;
  updatedBy: number;
  isDelete: boolean;
  deliveryBasePrice: number;
  KMExpense: number;
  note1: string;
  note2: string;
  note3: string;
};

export function b64toBlob(data: string, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

const ENDPOINT = "/vehicle-info";

export const saveVehicleInfo = (params: Partial<VehicleTourInfo>[]) =>
  axios.post<GenericResponse<VehicleTourInfo>>(`${ENDPOINT}/save`, { params });

export const listVehicleInfo = (date: string) =>
  axios.get<GenericListResponse<VehicleTourInfo>>(`${ENDPOINT}/list-by-date?date=${date}`);

export const exportVehicleInfo = (data: { param: string }) =>
  axios.post(`${ENDPOINT}/export`, data);
